export default __webpack_public_path__ + "static/media/nickel-plating-icon.51840679.svg";